const FETCH_ROUTES_BY_ID = 'FETCH_ROUTES_BY_ID'
const FETCH_ROUTE_DETAILS_BY_ID = 'FETCH_ROUTE_DETAILS_BY_ID'
const ROUTE_DETAILS_IS_LOADING = 'ROUTE_DETAILS_IS_LOADING'
const SET_PENDING_PROPOSAL_COUNT = 'SET_PENDING_PROPOSAL_COUNT'
const INCREMENT_PENDING_PROPOSAL_COUNT = 'INCREMENT_PENDING_PROPOSAL_COUNT'
const FETCH_REPLIES_BY_TRANSPORTER = 'FETCH_REPLIES_BY_TRANSPORTER'

export const bidDetailsActionTypes = {
  FETCH_ROUTES_BY_ID,
  FETCH_ROUTE_DETAILS_BY_ID,
  ROUTE_DETAILS_IS_LOADING,
  SET_PENDING_PROPOSAL_COUNT,
  INCREMENT_PENDING_PROPOSAL_COUNT,
  FETCH_REPLIES_BY_TRANSPORTER,
}
